module.exports = __webpack_public_path__ + "static/img/tg.53ea4f1f.svg";